import { notification } from "antd";
import axiosInstance from "../axiosInstance";
import { EnterpriseResponse } from "../../types/enterprise";

const patchSubAccount = async (
  id: string,
  data: EnterpriseResponse
): Promise<EnterpriseResponse> => {
  try {
    const response = await axiosInstance.patch<EnterpriseResponse>(
      `/account/subaccount/${id}`,
      data
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível atualizar a empresa.",
    });

    throw new Error(`${error}`);
  }
};

const defineSmartGoalsDone = async (
  id: string
): Promise<EnterpriseResponse> => {
  try {
    const response = await axiosInstance.patch<EnterpriseResponse>(
      `/account/subaccount/smart-goals-done/${id}`
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível atualizar a empresa.",
    });

    throw new Error(`${error}`);
  }
};

const getSubAccountById = async (id: string): Promise<EnterpriseResponse> => {
  try {
    const response = await axiosInstance.get<EnterpriseResponse>(
      `/account/subaccount/${id}`
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível buscar a empresa.",
    });

    throw new Error(`${error}`);
  }
};

export const subAccountService = {
  patchSubAccount,
  getSubAccountById,
  defineSmartGoalsDone,
};
